export default __webpack_public_path__ + "static/media/star-icon.2687104a.svg";